import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, X } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function TagManager() {
  const [tags, setTags] = useState([]);
  const [newTag, setNewTag] = useState("");

  const load = async () => { try { setTags((await api.get("/tags")).data); } catch {} };
  useEffect(() => { load(); }, []);

  const addTag = async () => {
    if (!newTag.trim()) return;
    try { await api.post("/tags", { name: newTag.trim() }); toast.success("Tag créé"); setNewTag(""); load(); } catch { toast.error("Erreur"); }
  };
  const deleteTag = async (id) => { try { await api.delete(`/tags/${id}`); toast.success("Tag supprimé"); load(); } catch {} };

  return (
    <div data-testid="tag-manager">
      <h1 className="font-heading text-3xl mb-6">Tags</h1>
      <div className="flex gap-2 mb-8">
        <Input value={newTag} onChange={(e) => setNewTag(e.target.value)} placeholder="Nouveau tag..." className="max-w-xs rounded-none" onKeyDown={(e) => e.key === "Enter" && addTag()} data-testid="new-tag-input" />
        <Button onClick={addTag} className="rounded-none" data-testid="add-tag-btn"><Plus className="h-4 w-4 mr-2" /> Ajouter</Button>
      </div>
      <div className="flex flex-wrap gap-3">
        {tags.map((tag) => (
          <div key={tag.id} className="flex items-center gap-1 border border-border px-3 py-1.5" data-testid={`tag-${tag.id}`}>
            <span className="font-mono text-sm">{tag.name}</span>
            <span className="text-xs text-muted-foreground ml-1">({tag.article_count})</span>
            <Button variant="ghost" size="icon" className="h-5 w-5 ml-1" onClick={() => deleteTag(tag.id)} data-testid={`delete-tag-${tag.id}`}><X className="h-3 w-3" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
}
